/**
 * フォームの情報
 */

const headList: any[] = [
  {
    headTitle: "施設名",
  },
  {
    headTitle: "職員名",
  },
  {
    headTitle: "生年月日",
  },
  {
    headTitle: "性別",
  },
  {
    headTitle: "加入年月日",
  },
  {
    headTitle: "職員の更新",
  },
];

const stepperData = ["内容入力・確認", "加入登録手続き確認", "機構へ提出"];
export { headList, stepperData };
